// extracted by mini-css-extract-plugin
export default {"cover":"o0Adv","thumbContainer":"_3r9nS","thumbWrapper":"VdiQ4"};